<template>
  <div>
    <hilo-button styleType="back" />
    <div v-if="payrolls">
      <div class="row" id="billableRow">
        <div class="customCard text-center payCard">
          <h3>Billable Hours:</h3>
          <h6>40</h6>
        </div>
        <div class="customCard text-center payroll">
          <h3>Non-Billable Hours:</h3>
          <h6>0</h6>
        </div>
      </div>
      <div class="col-sm-6">
        <!--class="row"-->
        <div class="row" id="payHistoryRow">
          <!-- <hilo-button
            class="bigBtn"

            label='Pending Pay'
          />
          <hilo-button
          class="bigBtn"
          label="View History"
          styleType="white"
          /> -->
          <button class="bigBtn" :class="payrolls[0].class">
            {{ payrolls[0].status }} Pay
          </button>
          <button class="bigBtn">View History</button>
        </div>
        <hilo-table :columns="paystub_columns" :data="payrolls" />
      </div>

      <div class="col-sm-6">
        <div class="row" id="formRow">
          <div>
            <button class="pending" @click="goToW9">W9</button>
          </div>
          <div>
            <button class="pending" @click="goToForms">Forms</button>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <h1>Payroll Submission Form</h1>
        <br />
        <h3>Name: {{ instructor.full_name }}</h3>
        <h4>Date: {{ today.toLocaleDateString() }}</h4>
        <h4>
          Submission Period: {{ daySufix(currentPayroll.startDate) }} -
          {{ daySufix(currentPayroll.endDate) }}
        </h4>
        <br />

        <div>
          <el-table :data="todaysTasks" style="width: 100%" height="25vh">
            <el-table-column
              label="Task Description"
              :min-width="150"
              align="center"
            >
              <template v-slot="scope">
                <el-input
                  v-model="scope.row.description"
                  placeholder="Description"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Hours" :min-width="150" align="center">
              <template v-slot="scope">
                <div class="row">
                  <div class="col-sm-4">
                    <input
                      type="time"
                      v-model="scope.row.startTime"
                      @change="handleTimeChange(scope.row, 'start')"
                    />
                  </div>
                  <div class="col-sm-4">
                    <input
                      type="time"
                      v-model="scope.row.endTime"
                      @change="handleTimeChange(scope.row, 'end')"
                    />
                    <div class="errorDialog" id="errorDialog">
                      Endtime must be after Start
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <el-time-select
                      v-model="scope.row.totalTime"
                      :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '12:00',
                      }"
                      placeholder="Total"
                      @change="handleTimeChange(scope.row, 'total')"
                    ></el-time-select>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Remove" width="75px" align="center">
              <template v-slot="scope">
                <el-button
                  type="danger"
                  class="deleteBtn"
                  @click="removeTask(scope.row)"
                  icon="el-icon-delete"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6">
          <div class="row" id="addSubmitRow">
            <div>
              <button class="pending" @click="addTask">Add +</button>
            </div>
            <div>
              <button class="submit" @click="submitTasks">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coming-soon-modal />
  </div>
</template>
<script>
/*
<el-table :data="payrolls"  style="width: 100%" height="25vh">
          <el-table-column label="Period" :min-width="150" align="center">
            <template v-slot="scope">
              <div > <!--class="row align-items-center"-->
                <div > <!--class="col-sm-3"-->
                  <el-button class="checkButton" @click="toggle(scope.row)">
                    <el-icon v-if="scope.row.selected" name="success filled" class="icon-green"></el-icon>
                    <el-icon v-else name="success filled" class="icon-invisible"></el-icon>
                  </el-button>
                </div>
                <div > <!--class="col-sm-9"-->
                  {{daySufix(scope.row.payDate)}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Status" :min-width="70" align="center">
            <template v-slot="scope">
              <i class="fas fa-clock" name="loading" v-if="scope.row.status === 'Pending'"></i>
              <i class="fas fa-check-circle green-check"></i>
              <i class="fas fa-times-circle red-x"></i>
              <!-- <el-icon class="elIcon loadingIcon" name="loading" v-if="scope.row.status === 'Pending'"></el-icon> -->
              <el-icon class="elIcon completeIcon" name="success" v-else-if="scope.row.status === 'Complete'"></el-icon>
              <el-icon class="elIcon rejectedIcon" name="close" v-else-if="scope.row.status === 'Rejected'"></el-icon>
              <el-icon class="elIcon invertIcon" name="question" v-else></el-icon>
            </template>
          </el-table-column>
          <el-table-column label="View" :min-width="130" align="center">
            <template v-slot="scope">
              <button v-if="scope.row.status !== 'Rejected'" :class="scope.row.class">{{scope.row.status}}</button>
              <button v-else :class="scope.row.class">{{scope.row.status}}: View</button>
            </template>
          </el-table-column>
          <el-table-column label="Hours" :min-width="70" align="center">
            <template v-slot="scope">
              {{scope.row.hours}}
            </template>
          </el-table-column>
          <el-table-column label="Follow Up" :min-width="140" align="center">
            <template v-slot="scope">
              <div v-if="scope.row.followUpRequired">
                <div v-if="scope.row.followUpDate">
                  {{daySufix(scope.row.followUpDate)}}
                </div>
                <div v-else>-</div>
              </div>
              <div v-else>n/a</div>
            </template>
          </el-table-column>
          <el-table-column label="Approved By" :min-width="140" align="center">
            <template v-slot="scope">
              {{scope.row.approvedBy.firstName}} {{scope.row.approvedBy.lastName}}
            </template>
          </el-table-column>
          <el-table-column label="Submitted" :min-width="140" align="center">
            <template v-slot="scope">
              {{ daySufix(scope.row.submittedDate) }}
            </template>
          </el-table-column>
        </el-table>
*/
import {
  Table,
  TableColumn,
  Button,
  Icon,
  TimePicker,
  TimeSelect,
} from "element-ui";
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import HiloButton from "src/components/HiloComponents/HiloButton.vue";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";
export default {
  name: "InstructorPayroll",//InstructorPayroll
  components: {
    ComingSoonModal,
    HiloTable,
    HiloButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [TimePicker.name]: TimePicker,
    [TimeSelect.name]: TimeSelect,
  },
  data() {
    return {
      instructorID: 0,
      instructor: null,
      payrolls: [],
      today: null,
      currentPayroll: null,
      todaysTasks: [],
      paystub_columns: [
        { key: "payDate", label: "Period" }, // TODO  {{daySufix(scope.row.payDate)}}
        { key: "status", label: "Status" },
        { key: "status", label: "View" },
        { key: "hours", label: "Hours" },
        { key: "followUpDate", label: "Follow Up" },
        { key: "approvedBy", label: "Approved By" },
        { key: "submittedDate", label: "Submitted" },
      ],
    };
  },
  async created() {
    this.instructorID = this.$route.query.instructor_id;
    this.getInstructor();
    this.getPayroll();
    window.onload = this.applyDynamicLoc;
    window.onresize = this.applyDynamicLoc;
  },
  methods: {
    getInstructor() {
      this.instructor = {
        id: 1,
        full_name: "Tyler Johnson",
        programId: 5,
        programName: "",
        balance: 300,
        lastSessionId: 7,
      };
      this.today = new Date();
    },
    getPayroll() {
      this.payrolls = [
        {
          id: 1,
          selected: false,
          status: "Pending",
          class: "pending",
          payDate: new Date("September 20 2024"),
          startDate: new Date("April 1 2024"),
          endDate: new Date("April 15 2024"),
          followUpDate: null,
          followUpRequired: true,
          submittedDate: new Date("April 15 2024"),
          hours: 15,
          approvedBy: {
            firstName: "Carly",
            lastName: "Orr",
          },
        },
        {
          id: 2,
          selected: false,
          status: "Complete",
          class: "complete",
          payDate: new Date("April 5 2024"),
          startDate: new Date("March 15 2024"),
          endDate: new Date("March 30 2024"),
          followUpDate: new Date("April 20 2024"),
          followUpRequired: true,
          submittedDate: new Date("April 1 2024"),
          hours: 23,
          approvedBy: {
            firstName: "Carly",
            lastName: "Orr",
          },
        },
        {
          id: 3,
          selected: false,
          status: "Rejected",
          class: "rejected",
          payDate: new Date("March 20 2024"),
          startDate: new Date("March 1 2024"),
          endDate: new Date("March 15 2024"),
          followUpDate: null,
          followUpRequired: false,
          submittedDate: new Date("March 15 2024"),
          hours: 7,
          approvedBy: {
            firstName: "Carly",
            lastName: "Orr",
          },
        },
      ];
      this.currentPayroll = this.payrolls[0];
    },
    goToProfile() {
      this.$router.push({
        name: "Profile Instructor",
      });
    },
    toggle(item) {
      item.selected = !item.selected;
    },
    goToW9() {
      alert("Went To W9 Page");
    },
    goToForms() {
      alert("Went To Forms Page");
    },
    daySufix(date) {
      switch (JSON.stringify(date.getDate()).slice(-1)) {
        case "1":
          return (
            date.toLocaleDateString(undefined, {
              month: "long",
              day: "numeric",
            }) + "st"
          );
        case "2":
          return (
            date.toLocaleDateString(undefined, {
              month: "long",
              day: "numeric",
            }) + "nd"
          );
        case "3":
          return (
            date.toLocaleDateString(undefined, {
              month: "long",
              day: "numeric",
            }) + "rd"
          );
        default:
          return (
            date.toLocaleDateString(undefined, {
              month: "long",
              day: "numeric",
            }) + "th"
          );
      }
    },
    addTask() {
      let temp = {
        description: "",
        startTime: "",
        endTime: "",
        totalTime: "",
      };
      this.todaysTasks.push(temp);
      this.$nextTick(() => {
        this.applyDynamicLoc();
      });
    },
    removeTask(task) {
      let index = this.todaysTasks.indexOf(task);
      this.todaysTasks.splice(index, 1);
    },
    handleTimeChange(task, sentBy) {
      switch (sentBy) {
        case "start":
          if (task.totalTime) {
            addTotalToStart();
            break;
          }
          if (task.startTime > task.endTime) {
            task.endTime = task.startTime;
          }
          updateTotal();
          break;
        case "end":
          if (task.totalTime) {
            subTotalForEnd();
            break;
          }
          if (task.startTime > task.endTime) {
            task.endTime = task.startTime;
            let target = document.getElementById("errorDialog");
            target.style.opacity = "100";
            setTimeout(() => {
              target.style.opacity = "0";
            }, "3000");
          }
          if (task.startTime) {
            updateTotal();
          }
          break;
        case "total":
          if (task.startTime) {
            addTotalToStart();
          } else if (task.endTime) {
            subTotalForEnd();
          }
          break;
      }
      if (task.endTime >= "24:00") {
        task.endTime = "23:59";
      }

      function updateTotal() {
        let startSplit = task.startTime.split(":");
        let startHours = parseInt(startSplit[0]);
        let startMins = parseInt(startSplit[1]);

        let endSplit = task.endTime.split(":");
        let endHours = parseInt(endSplit[0]);
        let endMins = parseInt(endSplit[1]);

        let totalHours = endHours - startHours;
        let totalMins = endMins - startMins;
        if (totalMins < 0) {
          totalHours--;
          totalMins += 60;
        }

        totalHours = "0" + totalHours;
        totalHours = totalHours.slice(-2);
        totalMins = "0" + totalMins;
        totalMins = totalMins.slice(-2);

        task.totalTime = totalHours + ":" + totalMins;
      }
      function addTotalToStart() {
        let startSplit = task.startTime.split(":");
        let startHours = parseInt(startSplit[0]);
        let startMins = parseInt(startSplit[1]);

        let totalSplit = task.totalTime.split(":");
        let totalHours = parseInt(totalSplit[0]);
        let totalMins = parseInt(totalSplit[1]);

        let endHours = startHours + totalHours;
        let endMins = startMins + totalMins;
        if (endMins >= 60) {
          endHours++;
          endMins -= 60;
        }

        endHours = "0" + endHours;
        endHours = endHours.slice(-2);
        endMins = "0" + endMins;
        endMins = endMins.slice(-2);

        task.endTime = endHours + ":" + endMins;
      }
      function subTotalForEnd() {
        let endSplit = task.endTime.split(":");
        let endHours = parseInt(endSplit[0]);
        let endMins = parseInt(endSplit[1]);

        let totalSplit = task.totalTime.split(":");
        let totalHours = parseInt(totalSplit[0]);
        let totalMins = parseInt(totalSplit[1]);

        let startHours = endHours - totalHours;
        let startMins = endMins - totalMins;
        if (startMins < 0) {
          startHours--;
          startMins += 60;
        }

        startHours = "0" + startHours;
        startHours = startHours.slice(-2);
        startMins = "0" + startMins;
        startMins = startMins.slice(-2);

        task.startTime = startHours + ":" + startMins;
      }
    },
    applyDynamicLoc() {
      let target = document.getElementById("errorDialog");
      let parent = target.offsetParent;
      target.style.left =
        "-" + (target.offsetWidth / 2 - parent.offsetWidth / 2) + "px";
      target.style.top = "-" + (target.offsetHeight + 4) + "px";
    },
    submitTasks() {
      alert("Tasks Submitted");
    },
  },
};
</script>
<style scoped>
h1,
h3,
h4,
h6 {
  margin: 0;
}
p {
  font-size: 16px;
  padding: 1em 1em;
}
td,
tr {
  padding: 0;
  margin: 0;
  border: none;
}
button {
  padding: 5px;
  border: 1px solid black;
  color: black;
  border-radius: 6px;
  width: 100%;
}
button:hover {
  color: #00bbff;
  border-color: #00bbff;
  background-color: white;
}
.pending {
  border-color: black;
  background-color: black;
  color: white;
}
.complete {
  border-color: black;
  color: #439877;
}
.rejected {
  border-color: black;
  color: #bb3431;
}
.pendingIcon {
  color: #f6931d;
}
.completeIcon {
  color: #439877;
}
.rejectedIcon {
  color: #bb3431;
}
.invertIcon {
  color: white;
  background-color: black;
  border-radius: 50%;
}
.elIcon {
  font-size: 28px;
}
.bigBtn {
  font-size: 20px;
  width: 10vw;
  border-radius: 3em;
}
.backBtn {
  width: 50px;
  height: 50px;
  font-size: 24px;
  padding: 0;
  text-align: center;
  z-index: 100;
  border-radius: 50%;
  border: 1px solid black;
}
.checkButton {
  align-self: center;
  margin: 0;
  padding: 0;
  width: 30px;
  height: 30px;
  background-color: #f7f8f9;
  border-color: #dedfdf;
  border-width: 2px;
}
.icon-green {
  color: #439877;
  font-size: 20px;
  padding: 0;
  margin: 0;
}
.icon-invisible {
  color: transparent;
  font-size: 20px;
  padding: 0;
  margin: 0;
}
.submit {
  background-color: #439877;
  border-color: #439877;
  color: white;
}
input {
  border: 1px #dedfdf solid;
  border-radius: 5px;
  height: 100%;
  width: 100%;
  padding: 0 10px;
}
input[type="time"]::-webkit-calendar-picker-indicator {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0) brightness(70%)
    contrast(100%);
}
.align-items-center {
  display: flex;
  align-items: center;
}
.errorDialog {
  color: #bb3431;
  position: absolute;
  background-color: #eeefef;
  white-space: nowrap;
  border-radius: 5px;
  z-index: 10;
  padding: 0 10px;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.errorDialog:after {
  content: "";
  position: absolute;
  left: calc(50% - 4px);
  bottom: -8px;
  background-color: inherit;
  width: 20px;
  height: 8px;
  z-index: 11;
  clip-path: polygon(100% 0, 50% 100%, 0 0);
}
.deleteBtn {
  background-color: #bb3431;
  border-color: transparent;
  width: 40px;
  height: 40px;
  font-size: 28px;
}
button {
  border-style: solid;
}
.bottom {
  bottom: 0;
  position: fixed;
  width: 100%;
  margin: 10px -15px;
}
#billableRow {
  float: right;
}
#billableRow,
#payHistoryRow,
#formRow,
#addSubmitRow {
  display: flex;
  flex-direction: row;
  gap: 15px;
  /* height: 80px; */
  margin: 10px;
}
.customCard {
  width: 10vw;
  height: 100%;
  align-content: space-evenly;
  background-color: #f0f0f0;
  border-radius: 2em;
  padding: 1em 1.5em;
}
.payCard {
  color: white;
  background-color: #2ab472;
}
.payroll {
  cursor: pointer;
}
</style>
